import { Icon, type TIconProps } from '~/components/icon'
import * as Comp from './helper-text.styles'

type THelperText = {
  withIcon?: boolean
  children: React.ReactNode
  iconSize?: TIconProps['size']
  iconName?: TIconProps['symbol']
  hasError?: boolean
  disabled?: boolean
  readonly?: boolean
  testID?: string
}

const defaultIcon: TIconProps['symbol'] = 'rdicon-warning-circle'

export function HelperText({
  children,
  withIcon = false,
  hasError = false,
  disabled = false,
  readonly = false,
  iconSize = 'medium',
  iconName = defaultIcon,
  testID,
}: THelperText) {
  const renderIconColor = (): TIconProps['color'] => {
    if (hasError) {
      return 'colorTextDangerAlternative'
    }
    if (disabled) {
      return 'colorTextNeutralDisabled'
    }
    if (readonly) {
      return 'colorTextNeutralReadonly'
    }
    return 'colorTextNeutralAlternative'
  }

  return (
    <Comp.Root testID={testID}>
      {withIcon && (
        <Icon
          size={iconSize}
          symbol={hasError ? defaultIcon : iconName}
          color={renderIconColor()}
        />
      )}
      <Comp.Label
        numberOfLines={2}
        disabled={disabled}
        readonly={readonly}
        hasError={hasError}
      >
        {children}
      </Comp.Label>
    </Comp.Root>
  )
}
